import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Collapsible from '@radix-ui/react-collapsible';
import { TransactionEditableAppeal } from './TransactionEditableAppeal';
import { TransactionEditableFund } from 'assets/js/pages/transactions/TransactionEditableFund';
import { TransactionEditableSoftCredits } from 'assets/js/pages/transactions/TransactionEditableSoftCredits';
import { TransactionEditableTeam } from 'assets/js/pages/transactions/TransactionEditableTeam';
import { TransactionEditableTeamMember } from 'assets/js/pages/transactions/TransactionEditableTeamMember';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';
import { useFlags } from 'launchdarkly-react-client-sdk';

const TransactionFunds = () => {
    const { data: transaction } = useCurrentTransactionOrById();
    const { transactionSoftCredits = false, appeals = false } = useFlags();

    return (
        <Collapsible.Root defaultOpen={true}>
            <Collapsible.Trigger
                className={
                    'group flex w-full items-center justify-between gap-2 rounded-md bg-gray-100 px-3 py-2'
                }
            >
                <p className={'text-sm font-medium'}>Funds & credit</p>
                <FontAwesomeIcon
                    className={'group-radix-state-open:rotate-180'}
                    icon={faChevronDown}
                />
            </Collapsible.Trigger>
            <Collapsible.Content className={'relative flex flex-col gap-4 px-3 py-4'}>
                <TransactionEditableFund />
                {(transaction?.campaign?.has_teams || transaction?.campaign_team) && (
                    <TransactionEditableTeam />
                )}
                {transaction?.campaign?.has_members && <TransactionEditableTeamMember />}
                {appeals && <TransactionEditableAppeal />}
                {transactionSoftCredits && <TransactionEditableSoftCredits />}
            </Collapsible.Content>
        </Collapsible.Root>
    );
};

export { TransactionFunds };
